import React, {useState, useEffect, use, useMemo, useRef} from 'react';
import { Link, useParams } from 'react-router-dom';
// import '../styles/global.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MenuAssociados from '../../components/MenuAssociados';
import { Edit } from '@mui/icons-material';

export default function Mensalidade() {
    const { ano, mes } = useParams();
    useEffect(() => {
        if (ano && mes) {
            sessionStorage.selectAnoMensalidades = ano;
            sessionStorage.selectMesMensalidades = mes;
        }
    }, [ano, mes]);
    // sessionStorage.selectMesMensalidades = mes;
    // sessionStorage.selectAnoMensalidades = ano;
    
    const [anoAtual, setAnoAtual] = useState(ano);
    const [mesAtual, setMesAtual] = useState(mes);
    const [valorPadrao, setValorPadrao] = useState('50.00');

    const [menuAberto, setMenuAberto] = useState(false);
    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };
    const toggleLogoff = () => {
        localStorage.clear();
        localStorage.setItem('loggedIn', false);
        localStorage.removeItem('user');
        sessionStorage.clear();
        
        navigate('/');
        window.location.reload();
    }

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

    //array de anos para select
    const [yearsSelect, setYearsSelect] = useState([]);
    // Gerar os anos para o select, começando do ano atual e retrocedendo até 2021
    const years = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = 2021;
        const yearsArray = [];

        // Adiciona o ano atual e retrocede até 5 anos ou o limite de 2021
        for (let i = 0; i <= 30; i++) {
        const year = currentYear - i;
        if (year >= startYear) {
            yearsArray.push(year);
        } else {
            break; // Para o loop se for menor que 2021
        }
        }
        return yearsArray;
    }, []); // Executa apenas uma vez
    
    // Atualiza o estado do select de anos quando a lista de anos for gerada
    useEffect(() => {
        setYearsSelect(years);
    }, [years]);

    const [mensalidades, setMensalidades] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);

    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');

    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }

        setSelectStatus(sessionStorage.selectStatusMensalidades !== undefined ? sessionStorage.selectStatusMensalidades : '99');
    }, []);

    function handleSelectAno(event) {
        sessionStorage.selectAnoMensalidades = event.target.value
        setAnoAtual(sessionStorage.selectAnoMensalidades)
        carregaMensalidades();
    }

    function handleSelectMes(event) {
        sessionStorage.selectMesMensalidades = event.target.value
        setMesAtual(sessionStorage.selectMesMensalidades)
        carregaMensalidades();
    }

    function handleSetValorPadrao(value) {
        sessionStorage.valorPadraoMensalidade = value;
        setValorPadrao(sessionStorage.valorPadraoMensalidade);
    }

    function handleAlterarStatus(event, mensalidade) {
        sessionStorage.setItem('lastClickedID', mensalidade.IdPessoa);
        // console.log("Item clicado ID:", sessionStorage.getItem('lastClickedID'));
        //abrir uma caixa de confirmação antes de alterar o status da mensalidade
        if (window.confirm(`Deseja realmente alterar o status da mensalidade de ${mensalidade.pesNome} para ${event.target.checked ? 'PAGO' : 'PENDENTE'}?`)) {
            gravarAlteracaoStatus(event, mensalidade);
        } else {
            // Se o usuário cancelar, reverter o estado do checkbox
            event.preventDefault();
            event.target.checked = !event.target.checked;
        }
    }

    function gravarAlteracaoStatus(event, mensalidade) {
        //handleClick(mensalidade.IdPessoa);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        setIsLoadingMOD(true);
        var novoStatus = event.target.checked ? 1 : 0;
        const dados = {
            IdMensalidade: mensalidade.IdMensalidade,
            IdPessoa: mensalidade.IdPessoa,
            mslMes: mesAtual,
            mslAno: anoAtual,
            mslMesAno: mensalidade.mslMesAno,
            mslValor: valorPadrao.replace(',', '.'),
            mslRecibo: mensalidade.mslRecibo,
            mslStatus: novoStatus,
            mslObservacoes: mensalidade.mslObservacoes,
            mslCriadoPor: mensalidade.mslCriadoPor === undefined 
                || mensalidade.mslCriadoPor === null
                || mensalidade.mslCriadoPor === '' 
                    ? sessionStorage.nomeUsuario 
                    : mensalidade.mslCriadoPor,
            mslCriadoEm: mensalidade.mslCriadoEm === undefined 
                || mensalidade.mslCriadoEm === null
                || mensalidade.mslCriadoEm === '' 
                    ? customFormatDate 
                    : mensalidade.mslCriadoEm,
            mslAlteradoPor: sessionStorage.nomeUsuario,
            mslAlteradoEm: customFormatDate,
            mslCodigoGUID: mensalidade.mslCodigoGUID === undefined 
                || mensalidade.mslCodigoGUID === null
                || mensalidade.mslCodigoGUID === '' 
                    ? 'mensalidade-' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) 
                    : mensalidade.mslCodigoGUID
        };
        
        let routeURL = "";
        if (parseInt(mensalidade.IdMensalidade) > 0) {
            routeURL = '/routes.php?metodo=atualizarMensalidade';    
        } else {
            routeURL = '/routes.php?metodo=novaMensalidade';
        }
            // console.log("Dados para envio:", dados);
            // console.log(routeURL);
            // return;
        axios
        .post(
            process.env.REACT_APP_API_URL + routeURL, 
            dados, 
            {
                headers: {
                    "X-Access-Token": token,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            // Atualiza a lista de mensalidades após alterar o status
            if (response.message !== 'Erro') {
                // Atualiza o status da mensalidade localmente para refletir a mudança
                setMensalidades(prevMensalidades =>
                    prevMensalidades.map(m =>
                        m.IdPessoa === mensalidade.IdPessoa
                            ? { ...m, mslStatus: mensalidade.mslStatus === 1 ? 0 : 1 }
                            : m
                    )
                );
                carregaMensalidades();
            }

            setIsLoadingMOD(false);
        })
        .catch(error => {
            console.error('Erro ao gravar a mensalidade:', error);
            setIsLoadingMOD(false);
        });
    }

    function handleEnviarRecibo(mensalidade) {
        sessionStorage.setItem('lastClickedID', mensalidade.IdPessoa);
        sessionStorage.reciboOrigem = "Mensalidade";
        navigate(`/EnviarRecibo`, { state: { registro: mensalidade } });
    }

    function handleExibirRecibo(mensalidade) {
        sessionStorage.setItem('lastClickedID', mensalidade.IdPessoa);
        sessionStorage.reciboOrigem = "Mensalidade";
        navigate(`/ViewPDF`, { state: { registro: mensalidade } });
    }
    // console.log("Ano Atual: " + anoAtual);
    // console.log("Mês Atual: " + mesAtual);

    //obter a lista de todos os associados e as mensalidades do ano e mês selecionado
    useEffect(() => {
        if (anoAtual && mesAtual) {
            var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
            setIsLoadingMOD(true);

            const dados = {
                Ano: sessionStorage.selectAnoMensalidades !== undefined ? sessionStorage.selectAnoMensalidades : anoAtual,
                Mes: sessionStorage.selectMesMensalidades !== undefined ? sessionStorage.selectMesMensalidades : mesAtual
            };

            axios
            .post(
                process.env.REACT_APP_API_URL + '/routes.php?metodo=obterLancamentosDeMensalidades', 
                dados, 
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                setMensalidades(response.data);
                setIsLoadingMOD(false);
            })
            .catch(error => {
                console.error('Erro ao obter as mensalidades:', error);
                setIsLoadingMOD(false);
            });
        }
    }, [anoAtual, mesAtual]);

    const rowRefs = useRef({});
    const [lastClickedID, setLastClickedID] = useState(null);
    // function handleClick(id) {
    //     localStorage.setItem('lastClickedID', id);
    //     setLastClickedID(id);
    //     //console.log("ID clicado:", id);
    //     // Aqui você pode adicionar qualquer lógica adicional que queira executar quando um item for clicado    
    //     }

    //obter a lista de todos os associados e as mensalidades do ano e mês selecionado
    function carregaMensalidades() {
        //obter a lista de todos os associados e as mensalidades do ano e mês selecionado
        const savedLastClickedID = localStorage.getItem('lastClickedID');
        
        if (anoAtual && mesAtual) {
            var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
            setIsLoadingMOD(true);

            const dados = {
                Ano: sessionStorage.selectAnoMensalidades !== undefined ? sessionStorage.selectAnoMensalidades : anoAtual,
                Mes: sessionStorage.selectMesMensalidades !== undefined ? sessionStorage.selectMesMensalidades : mesAtual
            };

            axios
            .post(
                process.env.REACT_APP_API_URL + '/routes.php?metodo=obterLancamentosDeMensalidades', 
                dados, 
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                setMensalidades(response.data);
                setIsLoadingMOD(false);

                // if(savedLastClickedID && rowRefs.current[savedLastClickedID]) {
                //     rowRefs.current[savedLastClickedID].focus();
                //     rowRefs.current[savedLastClickedID].scrollIntoView({ behavior: 'smooth', block: 'center' });
                //     localStorage.removeItem('lastClickedID');
                // }
            })
            .catch(error => {
                console.error('Erro ao obter as mensalidades:', error);
                setIsLoadingMOD(false);
            });
        }
    }    

    function handleRetornaMes(mes) {
      switch (mes) {
        case '1':
          return 'Janeiro';
        case '2':
          return 'Fevereiro';
        case '3':
          return 'Março';
        case '4':
          return 'Abril';
        case '5':
          return 'Maio';
        case '6':
          return 'Junho';
        case '7':
          return 'Julho';
        case '8':
          return 'Agosto';
        case '9':
          return 'Setembro';
        case '10':
          return 'Outubro';
        case '11':
          return 'Novembro';
        case '12':
          return 'Dezembro';
        default:
          return mes;
      }
    }

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
    }, []);

    useEffect(() => {
        // 1. Verifica se existe um ID guardado na memória do navegador
        const itemClicadoId = sessionStorage.getItem('lastClickedID');
        //console.log(itemClicadoId);
        if (itemClicadoId) {
          const elementoLinha = document.getElementById(`linha-${itemClicadoId}`);
          
          if (elementoLinha) {
            // Rola até a linha clicada de forma suave
            setTimeout(() => {
              elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
              // Destaque visual temporário opcional (ex: piscar a linha)
              elementoLinha.style.backgroundColor = '#fff9c4'; 
              setTimeout(() => elementoLinha.style.backgroundColor = '', 2000);
            }, 100); // Um pequeno delay garante que o HTML já renderizou
    
            // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
            sessionStorage.removeItem('lastClickedID');
          }
        }
      }, [mensalidades]);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Menu de navegação */}
                    <div>
                        <MenuAssociados />
                    </div>
                    
                    {/* Titulos da página */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >MENSALIDADE</label>
                        <h3>Lançamentos de Mensalidades</h3>
                    </div>

                    <div className="containerBarraPesquisa d-flex flex-wrap align-items-center justify-content-space-between">
                        {/* pesquisa por texto o nome */}
                        <input className="inputBarraPesquisa"
                        placeholder="PESQUISAR"
                        type="text"
                        id="inputPesquisa"
                        name="inputPesquisa"
                        onChange={event => {
                            setSearchTerm(event.target.value)
                        }}
                        />
                        {/* selects de ano */}
                        <select className="selectStatusPesquisa"
                            name="selectAnoMensalidade"
                            id="selectAnoMensalidade"
                            onChange={event => {
                                handleSelectAno(event);
                            }}
                        >
                            {yearsSelect.map((year) => (
                                <option key={year} value={year} selected={parseInt(anoAtual) === year}>{year}</option>
                            ))}
                            
                        </select>
                        {/* select mês */}
                        <select className="selectStatusPesquisa"
                            name="selectMesMensalidade"
                            id="selectMesMensalidade"
                            onChange={event => {
                                handleSelectMes(event);
                            }}
                        >
                            <option value="1" selected={parseInt(mesAtual) === 1}>Janeiro</option>
                            <option value="2" selected={parseInt(mesAtual) === 2}>Fevereiro</option>
                            <option value="3" selected={parseInt(mesAtual) === 3}>Março</option>
                            <option value="4" selected={parseInt(mesAtual) === 4}>Abril</option>
                            <option value="5" selected={parseInt(mesAtual) === 5}>Maio</option>
                            <option value="6" selected={parseInt(mesAtual) === 6}>Junho</option>
                            <option value="7" selected={parseInt(mesAtual) === 7}>Julho</option>
                            <option value="8" selected={parseInt(mesAtual) === 8}>Agosto</option>
                            <option value="9" selected={parseInt(mesAtual) === 9}>Setembro</option>
                            <option value="10" selected={parseInt(mesAtual) === 10}>Outubro</option>
                            <option value="11" selected={parseInt(mesAtual) === 11}>Novembro</option>
                            <option value="12" selected={parseInt(mesAtual) === 12}>Dezembro</option>
                        </select>
                        {/* input valor padrão para lançamentos */}
                        <input
                            type="text" inputMode='decimal'
                            placeholder="Valor padrão para lançamentos"
                            defaultValue={valorPadrao}
                            className="inputBarraPesquisa"
                            id="inputValorPadraoMensalidade"
                            name="inputValorPadraoMensalidade"
                            onChange={event => {
                                handleSetValorPadrao(event.target.value);
                            }}>
                        </input>
                        {/* input select para filtro do mslStatus */}
                        <select className="selectStatusPesquisa"
                        name="SelectStatusRegistro"
                        selected={sessionStorage.selectStatusMensalidades !== undefined ? sessionStorage.selectStatusMensalidades : '99'}
                        onChange={event => {
                            sessionStorage.selectStatusMensalidades = event.target.value;
                            setSelectStatus(sessionStorage.selectStatusMensalidades);
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusMensalidades === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusMensalidades === '1'} >PAGOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusMensalidades === '0'} >PENDENTES</option>
                        </select>
                        <button className="buttonModalPadrao" onClick={() => navigate(-1)}>
                            VOLTAR
                        </button>
                    </div>
                </div>

                {/* Tabela de mensalidades todos os associados */}
                <div className="tabelaPadrao">
                    {windowWidth < 769 ? 
                            isLoadingMOD ? (
                                <tr>
                                    <td colSpan="5" style={{ width: "100%", textAlign: "center"}}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            ) : (
                                mensalidades.length > 0 && mensalidades
                                .filter((mensalidade) => {
                                    if (searchTerm === '') {
                                        if (selectStatus === undefined || selectStatus === '' || selectStatus === '99') {
                                            return mensalidade;
                                        } else if (selectStatus === '1' && parseInt(mensalidade.mslStatus) === 1) {
                                            return mensalidade;
                                        } else if (selectStatus === '0' && parseInt(mensalidade.mslStatus) === 0) {
                                            return mensalidade;
                                        } 
                                    } else {
                                        if (selectStatus === undefined || selectStatus === '' || selectStatus === '99') {
                                            return mensalidade.pesNome.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        } else if (selectStatus === '1' && parseInt(mensalidade.mslStatus) === 1) {
                                            return mensalidade.pesNome.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        } else if (selectStatus === '0' && parseInt(mensalidade.mslStatus) === 0) {
                                            return mensalidade.pesNome.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        }
                                    }
                                    return false;
                                })
                                .map((mensalidade) => (
                                    <div key={mensalidade.IdPessoa} 
                                    className="p2" style={{ cursor: 'pointer', borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}
                                    >
                                        <p style={{ color: '#000', marginTop: '10px' }}><strong>Associado:</strong> {mensalidade.pesNome}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><strong>Mês/Ano:</strong> {mensalidade.mslMes}/{mensalidade.mslAno}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><strong>Valor:</strong> R$ {mensalidade.mslValor}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><strong>Status:</strong> {mensalidade.mslStatus === 1 ? 'Pago' : 'Pendente'}</p>
                                        {/* <p style={{ color: '#000', marginTop: '10px' }}><strong>Recibo:</strong> {mensalidade.mslRecibo || 'N/A'}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><strong>Observações:</strong> {mensalidade.mslObservacoes || 'N/A'}</p> */}
                                        {/* <div
                                            key={mensalidade.IdPessoa}
                                            ref={el => rowRefs.current[mensalidade.IdPessoa] = el}
                                            tabIndex="-1"
                                            >
                                                <label style={{ color: parseInt(mensalidade.mslStatus) === 1 ? 'green' : 'red' }}>
                                                <input
                                                type="checkbox"
                                                checked={parseInt(mensalidade.mslStatus) === 1 ? true : false}
                                                style={{ margin: '20px 10px 10px 0px', transform: 'scale(1.5)', cursor: 'pointer' }}
                                                onChange={event => { handleAlterarStatus(event, mensalidade) }}
                                                /> 
                                                {parseInt(mensalidade.mslStatus) === 1 ? 'PAGO - Marcar como Pendente' : 'PENDENTE - Marcar como Pago'}</label>
                                        </div> */}
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px' }}>
                                            <div>
                                                <button id={`linha-${mensalidade.IdPessoa}`} className="buttonGridPadrao" style={{margin: '5px', backgroundColor: parseInt(mensalidade.mslStatus) === 1 ? 'green' : 'red'}}
                                                    onClick={() => handleAlterarStatus({ target: { checked: parseInt(mensalidade.mslStatus) === 0 } }, mensalidade)}>
                                                    {parseInt(mensalidade.mslStatus) === 0 ? 'Pendente' : 'Pago'}
                                                    <Edit style={{width: '16px', marginBottom: '-7px', marginLeft: '5px'}} />
                                                </button>
                                            </div>

                                        {(parseInt(mensalidade.mslStatus) === 1 || parseInt(mensalidade.mslStatus) === 0)
                                        && mensalidade.mslRecibo === '' ? (
                                            <div className='tdAlignCenter' 
                                            onClick={() => handleEnviarRecibo(mensalidade)}>
                                            <button className="buttonGridPadrao2" >
                                                Anexar Recibo
                                            </button>
                                            </div>
                                        ) : 
                                        (
                                            <div className='tdAlignCenter'>
                                            <button className="buttonGridPadrao" style={{margin: '5px'}}
                                                onClick={() => handleExibirRecibo(mensalidade)}>
                                                Exibir
                                            </button>
                                            <button className="buttonGridPadrao2" 
                                                onClick={() => handleEnviarRecibo(mensalidade)}>
                                                Reenviar
                                            </button>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                ))
                            )
                     : 
                    <table className="tabelaDados">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left' }}>Associado</th>
                                <th style={{ textAlign: 'center' }}>Mês/Ano</th>
                                <th style={{ textAlign: 'right' }}>Valor</th>
                                {/* <th style={{ textAlign: 'center' }}>Status</th> */}
                                <th></th>
                                <th style={{ textAlign: 'center' }}>Recibo</th>
                                <th style={{ textAlign: 'left' }}>Observações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoadingMOD ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            ) : (
                                mensalidades.length > 0 && mensalidades
                                .filter((mensalidade) => {
                                    if (searchTerm === '') {
                                        if (selectStatus === undefined || selectStatus === '' || selectStatus === '99') {
                                            return mensalidade;
                                        } else if (selectStatus === '1' && parseInt(mensalidade.mslStatus) === 1) {
                                            return mensalidade;
                                        } else if (selectStatus === '0' && parseInt(mensalidade.mslStatus) === 0) {
                                            return mensalidade;
                                        } 
                                        // else {
                                        //     return mensalidade;
                                        // }
                                    } else {
                                        if (selectStatus === undefined || selectStatus === '' || selectStatus === '99') {
                                            return mensalidade.pesNome.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        } else if (selectStatus === '1' && parseInt(mensalidade.mslStatus) === 1) {
                                            return mensalidade.pesNome.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        } else if (selectStatus === '0' && parseInt(mensalidade.mslStatus) === 0) {
                                            return mensalidade.pesNome.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        } 
                                        // else {
                                        //     return mensalidade;
                                        // }
                                    }
                                })
                                .map((mensalidade) => (
                                    <tr key={mensalidade.IdPessoa} id={`linha-${mensalidade.IdPessoa}`}>
                                        <td>{mensalidade.pesNome}</td>
                                        <td style={{ textAlign: 'center' }}>{handleRetornaMes(mensalidade.mslMes)}/{mensalidade.mslAno}</td>
                                        <td style={{ textAlign: 'right' }}>R$ {mensalidade.mslValor}</td>
                                        <td style={{ textAlign: 'center', display: 'none' }}>
                                            {parseInt(mensalidade.mslStatus) === 1 ? 'PAGO' : 'PENDENTE'}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {/* <div
                                            key={mensalidade.IdPessoa}
                                            ref={el => rowRefs.current[mensalidade.IdPessoa] = el}
                                            tabIndex="-1"
                                            >
                                                <input
                                                type="checkbox"
                                                checked={parseInt(mensalidade.mslStatus) === 1 ? true : false}
                                                style={{ marginLeft: '20px', transform: 'scale(1.5)' }}
                                                onChange={event => { handleAlterarStatus(event, mensalidade) }}
                                                />  
                                            </div> */}
                                            <div>
                                                <button id={`linha-${mensalidade.IdPessoa}`} className="buttonGridPadrao" style={{margin: '5px', backgroundColor: parseInt(mensalidade.mslStatus) === 1 ? 'green' : 'red'}}
                                                    onClick={() => handleAlterarStatus({ target: { checked: parseInt(mensalidade.mslStatus) === 0 } }, mensalidade)}>
                                                    {parseInt(mensalidade.mslStatus) === 0 ? 'Pendente' : 'Pago'}
                                                    <Edit style={{width: '16px', marginBottom: '-7px', marginLeft: '5px'}} />
                                                </button>
                                            </div>
                                        </td>

                                        {(parseInt(mensalidade.mslStatus) === 1 || parseInt(mensalidade.mslStatus) === 0)
                                        && mensalidade.mslRecibo === '' ? (
                                            <td className='tdAlignCenter'
                                            onClick={() => handleEnviarRecibo(mensalidade)}>
                                            <button id={`linha-${mensalidade.IdPessoa}`} className="buttonGridPadrao2" >
                                                Anexar Recibo
                                            </button>
                                            </td>
                                        ) : 
                                        (
                                            <td className='tdAlignCenter'>
                                            <button id={`linha-${mensalidade.IdPessoa}`} className="buttonGridPadrao" style={{margin: '5px'}}
                                                onClick={() => handleExibirRecibo(mensalidade)}>
                                                Exibir
                                            </button>
                                            <button id={`linha-${mensalidade.IdPessoa}`} className="buttonGridPadrao2" 
                                                onClick={() => handleEnviarRecibo(mensalidade)}>
                                                Reenviar
                                            </button>
                                            </td>
                                        )}

                                        <td style={{ textAlign: 'left' }}>
                                            {(
                                                parseInt(mensalidade.mslStatus) === 1 
                                                ? 'Pagamento confirmado' 
                                                : parseInt(mensalidade.mslStatus) === 0 
                                                && mensalidade.mslRecibo !== '' 
                                                ? 'Aguardando confirmação' 
                                                : 
                                                mensalidade.mslObservacoes
                                            )}
                                            {/* {
                                                mensalidade.mslObservacoes
                                            } */}
                                        </td>
                                    </tr>
                                )) 
                            )}
                            {
                                mensalidades.message !== undefined && mensalidades.message !== null && mensalidades.message !== '' ? (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>
                                            {mensalidades.message}
                                        </td>
                                    </tr>
                                ) : ('')
                            }
                        </tbody>
                    </table>
                    }
                </div>

                {/* Botão para novo lançamento de mensalidade, apenas para admin */}
                {/* <div className="containerBarraPesquisa">
                    {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <Link to={`/Mensalidade/${anoAtual}/${mesAtual}`}>
                            <button className="buttonModalPadrao" onClick={handleNovoCadastro}>
                                NOVO LANÇAMENTO DE MÊS
                            </button>
                        </Link>
                    ) : ('')}
                </div> */}
            </main>
        </div>
    )
}